// src/pages/docs/game/coin.jsx
import { Typography, Box, Button } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const CoinCommand = () => {
  const location = useLocation();
  const command = commandList.find((cmd) => cmd.path === location.pathname);
  const { prev, next } = getAdjacentCommands(location.pathname);

  return (
    <DocsLayout>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth: 800 }}>
        {/* 왼쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, minWidth: 260 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            /코인, ?코인
          </Typography>
          <Typography variant="body1" sx={{ mt: -2, mb: 3 }}>
            {command?.description ?? '설명이 없습니다.'}
          </Typography>
          <Typography variant="h6">
            {"사용법: /코인 [유저], ?코인 [유저]"}<br />{"[]는 선택사항입니다."}
          </Typography>
        </Box>

        {/* 오른쪽 이미지 영역 */}
        <Box
          component="img"
          src="/commands/coin.webp"
          alt="설명 이미지"
          sx={{
            width: '100%',
            maxWidth: 366,
            borderRadius: 2,
            flexShrink: 0,
            mx: 'auto',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'space-between' },  // ✅ 모바일 중앙, 데스크탑 좌우
            gap: 4,
            width: { xs: '100%',md: 'auto' },
          }}
        >
          <Button href='/docs/overview' variant="outlined"sx={{height: 36, width:118 }}>
            ← 시작 페이지
          </Button>
        {next && (
          <Button href={next.path} variant="outlined"sx={{height: 36, width:118 }}>
            {next.name} →
          </Button>
        )}
        </Box>
      </Box>
    </DocsLayout>
  );
};

export default CoinCommand;
